import { Component, Input } from '@angular/core';
import { IHotlineAvailabilityResult } from 'src/models/app.model';

@Component({
  selector: 'liberro-help-box',
  standalone: false,
  templateUrl: './liberro-help-box.component.html',
  styleUrl: './liberro-help-box.component.less'
})
export class LiberroHelpBoxComponent {
  @Input() public icon = '';
  @Input({ required: true }) public hotlineAvailability: IHotlineAvailabilityResult | null = null;
  @Input({ required: true }) public headingTranslationKey = '';
  @Input({ required: true }) public contentTranslationKey = '';
  @Input({ required: true }) public emailTranslationKey = '';
}
